import { render } from "./Home.vue?vue&type=template&id=deada9ca"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=deada9ca&scored=true&lang=css"
script.render = render

export default script